import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  Row,
  Col,
  Form,
  Widget,
  Icon,
  GridView,
  CrudSimpleView,
  SimpleView,
  CompositeView,
  CrudContext,
  MasterDetailForm,
  FormInput,
  FormSubmitButton,
  FormatText,
} from '@digital/ui';
import { Collapse, Card, Icon } from 'antd';
import {
  TipoProjeto,
  getAllCategorias,
  getAllSubGrupos,
  getAllGrupos,
  createCategoria,
  updateCategoria,
  deleteCategoria,
  createGrupo,
  deleteGrupo,
  updateGrupo,
  createSubGrupo,
  updateSubGrupo,
  deleteSubGrupo,
} from '@app/api/tipoProjeto';
import {
  AcronimoProjeto,
  getAllAcronimosProjeto,
  createAcronimoProjeto,
  updateAcronimoProjeto,
  deleteAcronimoProjeto,
} from '@app/api/acronimosProjeto';
import TipoProjetoComponent from './TipoProjeto';
import AcronimoProjetosTableComponent from './AcronimoProjetoTable';
import { hasPermission } from '@app/helpers/permissions';

const { Panel } = Collapse;

const AcronimoProjetoProjetoComponent = () => {
  const [acronimos, setAcronimos] = useState<AcronimoProjeto[]>();
  const [categorias, setCategorias] = useState<TipoProjeto[]>();
  const [grupos, setGrupos] = useState<TipoProjeto[]>();
  const [subGrupos, setSubGrupos] = useState<TipoProjeto[]>();
  const [shouldUpdate, setShouldUpdate] = useState<boolean>(false);

  const fetchData = () => {
    const getCategorias = async () => {
      const result = await getAllCategorias();
      if (result) setCategorias(result);
    };

    const getGrupos = async () => {
      const result = await getAllGrupos();
      if (result) setGrupos(result);
    };

    const getSubGrupos = async () => {
      const result = await getAllSubGrupos();
      if (result) setSubGrupos(result);
    };

    const getAcronimoProjetos = async () => {
      const result = await getAllAcronimosProjeto();
      if (result) setAcronimos(result);
    };

    getCategorias();
    getGrupos();
    getSubGrupos();
    getAcronimoProjetos();
  };

  useEffect(() => fetchData(), []);
  useEffect(() => fetchData(), [shouldUpdate]);

  const validationSchema = Yup.object().shape({
    sigla: Yup.string().required('Sigla deve ser informada'),
    categoriaId: Yup.string().required('Categoria deve ser informada'),
    grupoId: Yup.string().required('Grupo deve ser informado'),
    subGrupoId: Yup.string().required('Sub-Grupo deve ser informad'),
  });

  const initialState: AcronimoProjeto = {
    id: '',
    sigla: '',
    categoriaId: '',
    grupoId: '',
    subGrupoId: '',
  };
  return (
    <SimpleView>
      <GridView noform>
        {true && (
          <>
            <AcronimoProjetosTableComponent
              titulo="Acrônimos"
              data={acronimos || []}
              categorias={(categorias && categorias.map(a => ({ text: a.data.nome, value: a.id.toString() }))) || []}
              grupos={(grupos && grupos.map(a => ({ text: a.data.nome, value: a.id.toString() }))) || []}
              subGrupos={(subGrupos && subGrupos.map(a => ({ text: a.data.nome, value: a.id.toString() }))) || []}
              handleCreate={createAcronimoProjeto}
              handleUpdate={updateAcronimoProjeto}
              handleDelete={deleteAcronimoProjeto}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

            <TipoProjetoComponent
              titulo="Categoria"
              label="Nome da Categoria"
              data={(categorias && categorias.sort((a, b) => a.data.codigo - b.data.codigo)) || []}
              handleCreate={createCategoria}
              handleUpdate={updateCategoria}
              handleDelete={deleteCategoria}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

            <TipoProjetoComponent
              titulo="Grupo"
              label="Nome do Grupo"
              data={(grupos && grupos.sort((a, b) => a.data.codigo - b.data.codigo)) || []}
              handleCreate={createGrupo}
              handleUpdate={updateGrupo}
              handleDelete={deleteGrupo}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />
            <TipoProjetoComponent
              titulo="Disciplina"
              label="Nome da Disciplina"
              data={(subGrupos && subGrupos.sort((a, b) => a.data.codigo - b.data.codigo)) || []}
              handleCreate={createSubGrupo}
              handleUpdate={updateSubGrupo}
              handleDelete={deleteSubGrupo}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />
          </>
        )}
      </GridView>
    </SimpleView>
  );
};

export default AcronimoProjetoProjetoComponent;
